import { TestimonialsPagination } from './TestimonialsPagination';
import { TestimonialCard } from './TestimonialCard';
import { testimonials } from '../../data/testimonials';
import { Button } from '../ui/button';
import { MessageCircle } from 'lucide-react';
import { usePagination } from '../../hooks/usePagination';

export const TestimonialsSection = ({ handleWhatsAppClick }) => {
const { currentPage: currentTestimonialPage, totalPages: totalTestimonialPages, pageItems: displayedTestimonials, previousPage, nextPage } = usePagination(testimonials, 6);
return (
<section id="temoignages" className="py-12 md:py-16 bg-gradient-to-b from-black to-gray-950">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <span className="inline-block bg-yellow-600/20 border border-yellow-600/40 text-yellow-400 px-6 py-2 rounded-full text-sm font-semibold mb-6">
              ⭐ 200+ Témoignages Authentiques
            </span>
            <h2 className="text-4xl md:text-6xl font-bold mb-6 text-red-600">
              Ils Ont Retrouvé l'Amour et le Bonheur
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
              280 clients satisfaits témoignent de l'efficacité extraordinaire des rituels du sorcier vaudou <strong className="text-white">Maître Diamma</strong>. 
              Découvrez leurs histoires authentiques de retour affectif, désenvoutement et transformation de vie.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto mb-12">
            {displayedTestimonials.map((testimonial) => (
              <TestimonialCard key={testimonial.id} testimonial={testimonial} />
            ))}
          </div>

          {/* Pagination */}
          <TestimonialsPagination currentTestimonialPage={currentTestimonialPage} totalTestimonialPages={totalTestimonialPages} previousPage={previousPage} nextPage={nextPage} />

          <div className="text-center mt-12 px-4">
            <p className="text-gray-400 mb-6">
              Rejoignez les clients satisfaits du marabout africain Maître Diamma
            </p>
            <Button 
              data-testid="testimonials-whatsapp-button"
              onClick={handleWhatsAppClick}
              size="lg"
              className="bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white text-base md:text-lg px-8 py-5 md:px-12 md:py-6 font-bold shadow-lg shadow-green-500/40 flex items-center justify-center mx-auto max-w-md"
            >
              <MessageCircle className="w-5 h-5 mr-2 flex-shrink-0" />
              <span>WhatsApp - Contact</span>
            </Button>
          </div>
        </div>
      </section>
);
};
